import React from 'react'
import withRedux from 'next-redux-wrapper'
import Theme from 'components/Theme'
import { App, Store } from 'apps/saatchi/collection'
import { Actions as AppActions } from 'apps/saatchi/collection/actions'
import { Actions as PageActions } from 'actions/page'
import { getDataLayer } from 'apps/saatchi/collection/selectors/dataLayer'
import { getMetaData } from 'apps/saatchi/collection/selectors/metadata'
import { storeSetup } from 'lib/pageSetup'

function Collection() {
  return (
    <Theme>
      <App />
    </Theme>
  )
}

Collection.clientSideTransitions = async ({ store }) => {
  if (window) {
    store.dispatch(AppActions.CLIENTSIDE_TRANSITION(window.location.href))
  }
}

Collection.getInitialProps = async ({ req, store, res, query }) => {
  // Client-Side
  if (!req) {
    Collection.clientSideTransitions({
      store,
      query,
    })
    const state = { ...store.getState() }
    const metaData = getMetaData(state)
    window.dataLayer.push({
      event: 'pageview',
    })
    return {
      metaData,
    }
  }

  // SSR
  storeSetup(store, req)
  const { page } = query
  store.dispatch(PageActions.SET(page))
  const {
    params: { ownerId, collectionId },
  } = query.page
  res.set(
    'Edge-Cache-Tag',
    `page-collectionDetail, userId-${ownerId}, page-collectionDetail-${collectionId}, page-collectionDetails-${ownerId}`
  )
  // Metadata & Datalayer
  const state = { ...store.getState() }
  const metaData = getMetaData(state)
  const dataLayer = getDataLayer(state)
  return {
    dataLayer,
    metaData,
  }
}

export default withRedux(Store)(Collection)
